import React, { useEffect, useRef, useState } from "react";
import { Input } from "antd";
import { HiMagnifyingGlass } from "react-icons/hi2";
import { CloseOutlined } from "@ant-design/icons";
import "./search.css";

const SearchComponent = ({ searchvalue, storeSearch,setOpen,open }) => {
 
 const inputRef = useRef(null);
  const handleOpen = () => {
    setOpen(true);
  };

 const handleCloseClick = () => {
    if (searchvalue && searchvalue.trim() !== "") {
      storeSearch(""); 
    } else {
      setOpen(false);
    }
  };
  useEffect(() => {
    if (open) {
      inputRef.current?.focus();
    }
  }, [open]);
  return (
    <div className="search-wrapper">
      <Input
      ref={inputRef}
        className={`search-input ${open ? "open" : "collapsed"}`}
        placeholder={open ? "Search" : ""}
        value={searchvalue}
        onChange={(e) => storeSearch(e.target.value)}
        prefix={
          <HiMagnifyingGlass
          style={{color: "black",fontSize:"25px"}}
            className="search-icon"
            onClick={handleOpen}
          />
        }
        suffix={
          open ? (
            <CloseOutlined
              onClick={handleCloseClick}
              className="close-iconn"
              style={{color:"#29b6f6"}}
            />
          ) : null
        }
      />
    </div>
  );
};

export default SearchComponent;


